import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { useBookingFlowContext } from '../../../booking-flow/BookingFlowProvider';
import type { TransferFlowState } from '../flowConfig';

export function TransferPrebookStep() {
  const flow = useBookingFlowContext<TransferFlowState>();
  const booking = flow.state.cart?.transferBookings?.[0];

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="subtitle1" gutterBottom>
        Ön Rezervasyon
      </Typography>
      <Stack spacing={1} sx={{ mb: 2 }}>
        <Typography variant="body2">Referans No: {booking?.referenceNumber ?? '—'}</Typography>
        <Typography variant="body2">Durum: {booking?.status ?? '—'}</Typography>
        <Typography variant="body2">
          Toplam Tutar: {booking?.totalFare?.toLocaleString('tr-TR')} {booking?.currency}
        </Typography>
      </Stack>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant="contained" disabled={flow.status === 'running'} onClick={() => flow.runStep()}>
          {flow.status === 'running' ? 'İşleniyor…' : 'Ön Rezervasyon Yap'}
        </Button>
      </Box>
    </Paper>
  );
}
